import CategoryContainer from "./CategoryContainer.svelte";
import TreeContainer from "./TreeContainer.svelte";

const container = document.getElementById('category-container');
const tree = document.getElementById('tree-popo');
const categoryData = JSON.parse(container.firstChild.textContent);
container.textContent = ''

export const app = new CategoryContainer({
	target: container,
	props: {
		categoryData: categoryData,
	},
	// hydrate: true
});

let _app;

if (tree) {
	_app = new TreeContainer({
		target: tree,
		props: {
			categoryData: categoryData,
		},
		// hydrate: true
	});
}

export const app1 = _app;
// export default app;
